const currentYear = new Date().getFullYear();
const filters = {
  'online-history': [
    { value: '1', text: 'Past 3 months', dateRange: 3 },
    { value: '2', text: 'Past 6 months', dateRange: 6 },
    { value: '3', text: 'Current Year', dateRange: currentYear },
    { value: '4', text: 'Last Year', dateRange: currentYear - 1 },
  ],
  'in-store-history': [
    { value: '1', text: 'Most Recent' },
    { value: '2', text: currentYear, dateRange: currentYear },
    { value: '3', text: currentYear - 1, dateRange: currentYear - 1 },
    { value: '4', text: currentYear - 2, dateRange: currentYear - 2 },
    { value: '5', text: currentYear - 3, dateRange: currentYear - 3 },
    { value: '6', text: currentYear - 4, dateRange: currentYear - 4 },
  ],
};

export const useOrderHistoryStore = defineStore('orderHistoryStore', {
  state: () => ({
    tabs: [
      {
        id: 'online-history',
        label: 'Online',
        searchable: false,
      },
      {
        id: 'in-store-history',
        label: 'In store',
        searchable: false,
      },
    ],
    dateFilters: filters,
    selectedDate: {
      online: undefined,
      store: undefined,
    },
    search: '',
    killSwitch: {},
  }),
  getters: {
    GET_TAB_IDS: (state) => {
      if (state.killSwitch?.inStorePurchasesDisabled) {
        return state.tabs.filter((tab) => tab.id !== 'in-store-history').map((tab) => tab.id);
      }
      return state.tabs.map((tab) => tab.id);
    },
    GET_DATE_FILTERS:
      (state) =>
      (tab = 'online-history', selectedDateRange = 0) => {
        const options = state.dateFilters[tab];
        let selectedDateOptionIndex = state.dateFilters[tab].findIndex((f) => f.dateRange?.toString() === selectedDateRange.toString());
        if (selectedDateOptionIndex === -1) selectedDateOptionIndex = tab === 'online-history' ? 1 : 0;
        if (!options[selectedDateOptionIndex]) throw new Error('Selected date option is not accessible');
        return {
          title: 'Order Date',
          default: selectedDateOptionIndex,
          options,
        };
      },
    GET_SELECTED_DATE_RANGE:
      (state) =>
      (tab = 'online-history') =>
        state.dateFilters[tab][state.selectedDate[tab] - 1]?.dateRange,
  },
  actions: {
    SET_SEARCH_KILLSWITCH({ searchable, tab }) {
      const existingTabState = [...this.tabs];
      const tabIndex = existingTabState.findIndex((t) => t.id === tab);
      existingTabState[tabIndex].searchable = searchable;
      this.tabs = [...existingTabState];
    },
    SET_SEARCH_QUERY(query) {
      this.search = query || '';
    },
    RESET_SEARCH_KILLSWITCH() {
      const existingTabState = [...this.tabs];
      existingTabState[0].searchable = false;
      existingTabState[1].searchable = false;
      this.tabs = [...existingTabState];
    },
    SET_KILLSWITCH(killSwitch) {
      this.killSwitch = killSwitch;
    },

    SET_SELECTED_DATE_RANGE({ tabName = 'online-history', value = 0, dateRange }) {
      let filterValue = value;
      if (!filterValue) {
        filterValue = tabName === 'online-history' ? 2 : 1;
      }
      if (dateRange) {
        const selectedDateOption = this.dateFilters[tabName].find((f) => f.dateRange?.toString() === dateRange.toString());
        if (selectedDateOption !== -1) this.selectedDate[tabName] = selectedDateOption;
      } else {
        const date = this.dateFilters[tabName][filterValue - 1];
        this.selectedDate[tabName] = date;
      }
    },
  },
});
